import React, { ReactNode } from "react";

interface PageContainerProps {
  children: ReactNode;
  widget?: ReactNode;
  isWidgetOpen?: boolean;
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  widget,
  isWidgetOpen = false,
}) => {
  return (
    <div className="h-full flex flex-col md:flex-row">
      <div className="flex-1 flex flex-col bg-white dark:bg-gray-800 rounded-t-lg mr-0.5 shadow-lg ml-0.5 min-w-0">
        {children}
      </div>
      {isWidgetOpen && widget && (
        <div className="w-full md:w-1/3 lg:w-1/4 mt-4 md:mt-0 h-full overflow-auto shrink-0">
          {widget}
        </div>
      )}
    </div>
  );
};
